var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReason2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 22H11.0165C8.87057 21.999 6.7718 21.3703 4.9787 20.1914C3.18561 19.0125 1.77649 17.3349 0.924922 15.3651C0.0733526 13.3954 -0.183478 11.2196 0.186064 9.10573C0.555607 6.99186 1.53538 5.03224 3.00471 3.46825C4.47404 1.90425 6.36874 0.804184 8.45546 0.303543C10.5422 -0.197097 12.7298 -0.076446 14.7488 0.650636C16.7677 1.37772 18.53 2.67948 19.8184 4.39557C21.1068 6.11167 21.8652 8.16715 22 10.3088V10.3666V22ZM11.0165 1.83333C8.58535 1.83333 6.25377 2.7991 4.53469 4.51819C2.8156 6.23727 1.84983 8.56885 1.84983 11C1.84983 13.4312 2.8156 15.7627 4.53469 17.4818C6.25377 19.2009 8.58535 20.1667 11.0165 20.1667H20.1667V10.3959C20.0095 8.07521 18.9775 5.90061 17.2791 4.31129C15.5807 2.72198 13.3425 1.83638 11.0165 1.83333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 6.4165H6.41675V8.24984H11.9167V6.4165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5834 10.0835H6.41675V11.9168H15.5834V10.0835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5834 13.75H6.41675V15.5833H15.5834V13.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason2);
export default __webpack_public_path__ + "static/media/reason2.cc28147407a737f8a7a8a123107e765a.svg";
export { ForwardRef as ReactComponent };